import type {
	Components,
} from '@mui/material'

export const materialUILinkTheme: {
	components: Components
} = {
	components: {
		MuiLink: {
			styleOverrides: {
				root: {
				},
			},
		},
	},
}
